import { NetSuiteAsset, BulkAssignFormattedResult } from 'types'

/**
 * Formats a date value to a consistent string format
 */
const formatDate = (date: string | Date | undefined | null): string => {
  if (!date) return ''
  if (typeof date === 'string') return date
  return date.toISOString()
}

/**
 * Formats boolean value to string for display
 */
const formatBoolean = (value: boolean | undefined): string => {
  return value !== undefined ? String(value) : 'false'
}

/**
 * Safely converts a value to string
 */
const safeToString = (value: number | string | undefined | null): string => {
  return value?.toString() || ''
}

/**
 * Transforms NetSuite asset data into formatted results for display
 */
export const formatUploadResults = (
  data: NetSuiteAsset[] | undefined | null
): BulkAssignFormattedResult[] => {
  if (!data || !Array.isArray(data)) {
    return []
  }

  return data.map((item: NetSuiteAsset) => ({
    LicenseId: item.nsName || '',
    siteId: safeToString(item.site?.id),
    siteName: item.site?.name || '',
    productDescription: item.product?.description || '',
    status: item.status || '',
    isActive: formatBoolean(item.isActive),
    adminEmail: item.adminEmail || '',
    startDate: formatDate(item.startDate),
    expirationDate: formatDate(item.expirationDate),
  }))
}

